import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Ordering: the storefront (groups, products, the cart and checkout) for everyone, the client's
 * order history, and the admin order queue with an Orders tab on the client page.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const store = () => import('./store.jsx');
const cart = () => import('./cart.jsx');
const client = () => import('./client.jsx');
const admin = () => import('./admin.jsx');

const ClientOrdersTab = (() => {
  const Lazy = lazy(() => admin().then((m) => ({ default: m.ClientOrdersTab })));
  return function Deferred(props) {
    return (
      <Suspense fallback={<Loading />}>
        <Lazy {...props} />
      </Suspense>
    );
  };
})();

export default {
  name: 'orders',
  publicRoutes: [
    { path: 'store', lazy: page(store, 'StoreHome') },
    { path: 'store/product/:slug', lazy: page(store, 'ProductPage') },
    { path: 'store/:group', lazy: page(store, 'GroupPage') },
    { path: 'cart', lazy: page(cart, 'Cart') },
    { path: 'checkout', lazy: page(cart, 'Checkout') },
    { path: 'checkout/complete/:uuid', lazy: page(cart, 'OrderComplete') },
  ],
  clientRoutes: [
    { path: 'orders', lazy: page(client, 'ClientOrders') },
    { path: 'orders/:uuid', lazy: page(client, 'ClientOrder') },
  ],
  adminRoutes: [
    { path: 'orders', lazy: page(admin, 'AdminOrders') },
    { path: 'orders/:uuid', lazy: page(admin, 'AdminOrder') },
  ],
  clientNav: [
    { key: 'store', to: '/store', order: 5 },
    { key: 'cart', to: '/cart', order: 6 },
    { key: 'orders', to: '/orders', label: 'Orders', order: 45, auth: true },
  ],
  adminNav: [{ section: 'clients', to: '/admin/orders', label: 'Orders', permission: 'admin.orders.read', order: 20 }],
  adminClientTabs: [
    { key: 'orders', label: 'Orders', order: 20, permission: 'admin.orders.read', Component: ClientOrdersTab },
  ],
};
